module.exports = __webpack_public_path__ + "img/TOP4.f5e22dfd.png";